import React from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";

const CheckApiRequests = (props) => {
  const state = useSelector((state) => state);

  let apiErrorLoggingMode = false;
  function addErrorPopup(infoError) {
    var style = document.createElement("style");
    style.innerHTML = `
			.apiErrorInfo{
				margin-top: 72px;
				background: white;
				max-width:709px;
				border-radius:6px;
				display: inline-block;
				text-align: left;
			}

			.apiErrorInfo h2{
				margin-bottom: 8px;
				display: flex;
				font-size:24px;
				line-height:30px;
				font-weight:600;
			}
			 .apiErrorInfo .icon {
					width: 32px;
					height: 32px;
					color:#c90032;
					margin-right: 10px;
					top: -1px;
					position: relative;
			}

			.apiErrorInfo p{
				font-size:16px;
				line-height:28px;
				margin-top: 20px;
			}

			@media screen and (max-width: 728px){
				.apiErrorInfo{
					margin-top: 32px;
					max-width:100%;
					padding: 21px 20px 10px;
				}
				.apiErrorInfo h2{
					display: grid;
				}
				.apiErrorInfo .icon {
					margin-bottom: 10px;
				}
			}`;
    // Get the first script tag
    var ref = document.querySelector("script");

    // Insert our new styles before the first script tag
    ref.parentNode.insertBefore(style, ref);

    const closeIcon =
      '<svg class="MuiSvgIcon-root icon" focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation"><path fill="#c90032" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"></path></svg>';

    let applicationIDRow = "";
    if (state.application && state.application.applicationNo) {
      applicationIDRow =
        "<p><strong>Application Number:</strong><br>" +
        state.application.applicationNo +
        "</p>";
    }
    if (infoError.serverDown == false) {
      document.getElementById("sectionMain").innerHTML =
        `<div class="apiErrorInfo">
					<h2>` +
        closeIcon +
        ` Sorry, we were unable to process your request</h2>
					<p>We apologise for any inconvenience caused. Our team is working to resolve this as quickly as possible.</p>
					<p>Please try again later. If this error persists, please contact the agency listed below.</p>
					<p><strong>Reference:</strong><br/>` +
        infoError.data.traceId +
        `</p>
					<p><strong>Date & time:</strong><br>` +
        moment(infoError.data.timestamp).format("DD/MM/YYYY hh:mm:ss a") +
        `</p>` +
        applicationIDRow +
        `</div>`;
    } else {
      document.getElementById("sectionMain").innerHTML =
        `<div class="apiErrorInfo">
					<h2>` +
        closeIcon +
        ` Server down</h2>
					<p>Our team is working to resolve this as quickly as possible. Please try again in an hour.</p>
				</div>`;
    }
  }
  function storeErrorData(error) {
    const applicationID =
      state.application && state.application.applicationId
        ? state.application.applicationId
        : "";
    const applicationNo =
      state.application && state.application.applicationNo
        ? state.application.applicationNo
        : "";

    //if (!application.applicationNo) {}
    const data = {
      apiUrl: error.response ? error.response.config.url : "",
      statusCode: error.response ? error.response.status : "NA",
      pageUrl: window.location.href,
      errorMessage: JSON.stringify({
        applicationid: applicationID,
        applicaitonno: applicationNo,
        error: error.response ? error.response.statusText : "NA",
      }),
    };

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/nativespeciesapi/V1/logger/apierror`,
        {
          ...data,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(function (response) {
        apiErrorLoggingMode = false;
        addErrorPopup({ serverDown: false, data: response.data });
      })
      .catch(function (error) {
        if (document.getElementById("apiErrorContainer") == null) {
          addErrorPopup({ serverDown: true, data: null });
        }
      });
  }
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (apiErrorLoggingMode == false) {
        apiErrorLoggingMode = true;
        if (!error.response) {
          addErrorPopup({ serverDown: true, data: null });
        }
        if (error.response.status != 400) {
          storeErrorData(error);
        }
      }
      return Promise.reject(error);
    }
  );

  return <div>{props.children}</div>;
};

export default CheckApiRequests;
